<template>
  <div class="size-chart-view">
    <div class="scv-tabs">
      <button
        v-for="(product, pi) in workbench.products"
        :key="pi"
        class="scv-tab"
        :class="{ active: activeTab === pi }"
        @click="activeTab = pi"
      >{{ product.name }}</button>
    </div>
    <div class="scv-content">
      <SizeChartForm :product-index="activeTab" />
      <SizeChartResult :product-index="activeTab" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import SizeChartForm from '@/components/size-chart/SizeChartForm.vue'
import SizeChartResult from '@/components/size-chart/SizeChartResult.vue'

const workbench = useWorkbenchStore()
const activeTab = ref(0)
</script>

<style scoped>
.size-chart-view {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.scv-tabs {
  display: flex;
  gap: 8px;
}
.scv-tab {
  padding: 8px 28px;
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  background: #fff;
  color: #4e5969;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s;
}
.scv-tab:hover { border-color: #165dff; color: #165dff; }
.scv-tab.active {
  background: #165dff; color: #fff; border-color: #165dff; font-weight: 600;
}
.scv-content {
  display: flex;
  gap: 24px;
}
.scv-content > * {
  flex: 1;
  min-width: 0;
}
</style>
